import { Component, OnInit } from '@angular/core';
import { Order } from '../../models';
import { Store } from '@ngrx/store';
import { ApplicationState } from '../../../application-state/store';
import { BaseOnDestroyComponent } from '../../../shared/injectables/BaseOnDestroy.component';

@Component({
  selector: 'app-missing-review-of-analysis-widget',
  styleUrls: ['./missing-review-of-analysis-widget.component.scss'],
  template: `
    <div class="wrapper  p-y--8">
      <div class="widget card">
        <div class="widget_header ps-1">
          <span>
            <button mat-icon-button (click)="loadData()">
              <mat-icon>autorenew</mat-icon></button
            >Überprüfung der Analysen</span
          >
        </div>
        <app-orders-list-for-widget
          [indicatorStyleFn]="getCircleColor"
          [states]="states"
        ></app-orders-list-for-widget>
      </div>
    </div>
  `
})
export class MissingReviewOfAnalysisWidgetComponent
  extends BaseOnDestroyComponent
  implements OnInit {
  states: string[];

  constructor(private store$: Store<ApplicationState>) {
    super();
  }

  ngOnInit(): void {
    this.states = [
      'analysis_purchase_prices_provided_dr_ext',
      'analysis_purchase_prices_provided_dr_remote',
      'analysis_completed_dr_de',
      'analysis_completed_dr_de_remote'
    ];
  }

  loadData(): void {
    this.states = [...this.states];
  }

  getCircleColor(order: Order): { [key: string]: string } {
    return { backgroundColor: '#ffc400' };
  }
}
